import type { ComponentProps } from 'react';

import { NotificationHeadingLevel } from 'src/components/NotificationBanner/NotificationBanner';

type NotificationBannerHeadingProps = ComponentProps<'h2'> & {
  level: NotificationHeadingLevel;
};

export const NotificationBannerHeading = (props: NotificationBannerHeadingProps) => {
  const { level, className, children, ...rest } = props;
  const Tag = level;

  return (
    <Tag
      className={`col-start-1 text-std-17B-170 text-solid-gray-900 desktop:mt-0.5 desktop:text-std-20B-160 ${className ?? ''}`}
      {...rest}
    >
      {children}
    </Tag>
  );
};
